export type ArticleContent = { Id: number, Title: string, SourceAddress: string, Content: string, KeywordIDs: number[], QuestionIDs: number[] };
export type Article = { Id: number, Title: string, Url: string, KeywordIDs: number[], QuestionIDs: number[] };
export type Keyword = { Id: number, Name: string };
export type Question = { Id: number, Name: string };
export class ScrapResult {
  markdown: string;
  html: string;
  title: string;
  success: boolean | null;
  error: string | null;

  static withError(error: string): ScrapResult {
    return new ScrapResult('', '', '', null, error);
  }

  static withSuccess(markdown: string, html: string, title: string): ScrapResult {
    return new ScrapResult(markdown, html, title, true);
  }

  constructor(markdown: string, html: string, title: string, success: boolean | null = null, error: string | null = null) {
    this.markdown = markdown;
    this.html = html;
    this.title = title;
    this.success = success;
    this.error = error;
  }
}

export class SummaryStats {
  articlesCount: number;
  keywordsCount: number;
  questionsCount: number;
  title: string;
  success: boolean | null;
  error: string | null;
  
  static withError(error: string): SummaryStats {
    return new SummaryStats(0, 0, 0, '', null, error);
  }

  constructor(articlesCount: number, keywordsCount: number, questionsCount: number, title: string, success: boolean | null = null, error: string | null = null) {
    this.articlesCount = articlesCount;
    this.keywordsCount = keywordsCount;
    this.questionsCount = questionsCount;
    this.title = title;
    this.success = success;
    this.error = error;
  }
}
